<form [formGroup]="personaFormGroup">
  <div class="row">
    <h4 class="second-header"> Nombre completo</h4>
  </div>
  <div class="row">
    <mat-form-field class="col-xs-12">
      <input matInput formControlName="nombre_completo" placeholder="Nombre completo:" readonly>
      <mat-error *ngIf="personaFormGroup.get('nombre_completo')?.hasError('required')">
        Debe ingresar nombre completo
      </mat-error>
    </mat-form-field>
    <div class="second-row">
      <mat-form-field class="col-xs-12">
        <input matInput formControlName="primer_nombre" placeholder="Primer nombre:"
          [readonly]="this._formInput.user.primer_nombre != ''">
      </mat-form-field>
      <mat-form-field class="col-xs-12">
        <input matInput formControlName="segundo_nombre" placeholder="Segundo nombre:"
          [readonly]="this._formInput.user.segundo_nombre != ''">
      </mat-form-field>
      <mat-form-field class="col-xs-12">
        <input matInput formControlName="primer_apellido" placeholder="Primer apellido:"
          [readonly]="this._formInput.user.primer_apellido != ''">
      </mat-form-field>
      <mat-form-field class="col-xs-12">
        <input matInput formControlName="segundo_apellido" placeholder="Segundo apellido:"
          [readonly]="this._formInput.user.segundo_apellido != ''">
      </mat-form-field>
    </div>
  </div>
  <rpe-documento-persona-form [formInput]="documentoPersonaFormInput"></rpe-documento-persona-form>
  <div class="row">
    <div class="birth-datepicker">
      <mat-form-field class="col-xs-6 input-field">
        <input matInput formControlName="fecha_nacimiento" placeholder="Fecha nacimiento:" required
          (input)="onDateChange($event)" #datepicker [max]="maxDate">
        <mat-error *ngIf="personaFormGroup.get('fecha_nacimiento').hasError('required')">
          Debe ingresar fecha nacimiento
        </mat-error>
        <mat-error *ngIf="personaFormGroup.get('fecha_nacimiento').hasError('format')">
          Debe escribir la fecha en el formato: DD/MM/YYYY; Ej: 01/06/2023
        </mat-error>
        <mat-error *ngIf="personaFormGroup.get('fecha_nacimiento').hasError('maxDate')">
          Debe ingresar una fecha igual o menor al dia de hoy
        </mat-error>
        <!-- <mat-error *ngIf="personaFormGroup.get('fecha_nacimiento')?.hasError('invalidDate')">
        Debe ingresar una fecha anterior al día de hoy
      </mat-error> -->
      </mat-form-field>
      <mat-form-field class="col-xs-6 datepicker-field">
        <input matInput formControlName="fecha_nacimiento" [matDatepicker]="picker" required
          (dateChange)="dateChange($event)">
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker></mat-datepicker>
      </mat-form-field>
    </div>
  </div>

  <ng-container *ngIf="sexosBio$ | async as tipoSexoBiologico">
    <div class="row sexo-radio-button">
      <p>Sexo:</p>
      <mat-radio-group>
        <mat-radio-button *ngFor="let tipoSexo of tipoSexoBiologico" [value]="tipoSexo.id"
          (change)="onSexoBioChange($event)">{{ tipoSexo.nombre
          }}</mat-radio-button>
      </mat-radio-group>
      <mat-error class="checkbox-error"
        *ngIf="personaFormGroup.get('sexo_biologico_id').touched && personaFormGroup.get('sexo_biologico_id')?.hasError('required')">
        Debe seleccionar sexo
      </mat-error>
    </div>
  </ng-container>

  <div class="row sexo-radio-button">
    <p>Identidad de género:</p>
    <mat-radio-group (change)="onSexoChange($event)">
      <mat-radio-button *ngFor="let sexo of sexos" [value]="sexo.id">{{
        sexo.nombre
        }}</mat-radio-button>
      <mat-radio-button [value]="0">Otro</mat-radio-button>
    </mat-radio-group>
    <mat-error class="checkbox-error"
      *ngIf="personaFormGroup.get('identidad_genero_id').touched && personaFormGroup.get('identidad_genero_id')?.hasError('required')">
      Debe seleccionar identidad de género
    </mat-error>
  </div>
  <div class="row">
    <mat-form-field *ngIf="showOtherField">
      <input matInput placeholder="Otro:" formControlName="identidad_genero_otro">
    </mat-form-field>
  </div>

  <div class="row">
    <h4 class="second-header"> Domicilio</h4>
  </div>
  <div class="row">
    <rpe-direcciones-geograficas-form [formInput]="direccionGeograficaFormInput"
      (formStatusChanges)="direccionGeograficaStatusChange($event)"
      (formValueChanges)="direccionGeograficaChange($event)">
    </rpe-direcciones-geograficas-form>
  </div>

  <div class="row">
    <h4 class="second-header"> Contacto</h4>
  </div>
  <div class="row">
    <rpe-telefonos-form [formInput]="formInputTelefono" (formStatusChanges)="telefonoFormStatusChange($event)"
      (formValueChanges)="telefonoFormValueChange($event)"></rpe-telefonos-form>
  </div>

  <div class="row">
    <ng-container formGroupName="correo_electronico">
      <mat-form-field class="col-xs-12">
        <input matInput placeholder="Correo electrónico:" formControlName="direccion" required>
        <mat-error *ngIf="personaFormGroup.get('correo_electronico')?.get('direccion').hasError('required')">
          Debe ingresar un correo electrónico
        </mat-error>
        <mat-error *ngIf="personaFormGroup.get('correo_electronico')?.get('direccion').hasError('email')">
          {{" Debe ingresar un correo electrónico válido (ejemplo@correo.com)"}}
        </mat-error>
      </mat-form-field>
    </ng-container>
  </div>
  <div class="row aceptaTerminosClass">
    <mat-checkbox class="col" formControlName="acepta_terminos">
      <span> Acepto los <span class="color" (click)="openTerminoCondiciones()">términos y condiciones</span></span>
    </mat-checkbox>
    <mat-error class="checkbox-error"
      *ngIf="personaFormGroup.get('acepta_terminos').touched && personaFormGroup.get('acepta_terminos')?.hasError('required')">
      Debe aceptar los términos y condiciones
    </mat-error>
  </div>
</form>